import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@/assets/style/base.css'
import '@/assets/style/font.css'
import './permission' // permission control
import { Checkbox } from 'element-ui'
Vue.config.productionTip = false;
Vue.component(Checkbox.name, Checkbox)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
